import axios from 'axios';
import { getStoredData, get_auth_key } from '../../util';
const storedData = JSON.parse(getStoredData(get_auth_key()));

const getHeaders = (multiPartRequest = false) => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  return {
    Accept: 'application/json',
    'Content-Type': multiPartRequest ? 'multipart/form-data' : 'application/json',
    'x-access-token': storedData.token,
    'factory-id': localStorage.getItem('factoryId'),
  };
};

export const createRequest = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/machine", settings);

    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getSec = async (factoryId) => {
  const settings = {
    method: "GET",
    headers: getHeaders(),
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/section?factoryId=${factoryId}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getMachineRequestAPI = async (pageNo, perPageCount, options) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = "";
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/machine?page=${pageNo}&limit=${perPageCount}${query}`, settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getRequestAPI = async (pageNo, perPageCount, options, machineRequestId = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleMachineRequest = '';
    if (machineRequestId !== 0) {
      singleMachineRequest = `/${machineRequestId}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/mm/machine${singleMachineRequest}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const editRequest = async (id, request) => {
  const settings = {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/machine/${id}`, settings);
    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const deleteRequest = async (id) => {
  const settings = {
    method: "DELETE",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/machine/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getMachineRequest = async (id) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/machine/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const createQuotation = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/quotation", settings);
    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getQuotationRequest = async (id) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/quotation/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};
export const getSingleQuotationRequest = async (id) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/quotation/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getQuotationListRequest = async (pageNo, perPageCount, id, options) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(
      process.env.REACT_APP_BASE_URL + `/mm/quotation?page=${pageNo}&limit=${perPageCount}&id=${id}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const editQuotation = async (id, request) => {
  const settings = {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/quotation/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const deleteQuotation = async (id) => {
  const settings = {
    method: "DELETE",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/quotation/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const createQuotationRef = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/quotation-reference", settings);
    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getQuotationRefListRequest = async (pageNo, perPageCount, id, options) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/quotation-reference?page=&limit=${perPageCount}&id=${id}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getReferenceRequest = async (referenceId, quotationId) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/machine-requests/${quotationId}/references/${referenceId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const editQuotationRef = async (id, request) => {
  const settings = {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/quotation-reference/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const deleteQuotationRef = async (id) => {
  const settings = {
    method: "DELETE",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/quotation-reference/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const approveQuotation = async (MachineId, quotationId) => {
  try {
    const res = await axios.put(
      process.env.REACT_APP_BASE_URL + `/mm/machine-requests/${MachineId}/quotations/${quotationId}?update_status=true`,
      [],
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const createPurchaseOrder = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/purchase-order", settings)
    .then((resp) => {
      return resp.json();
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        // unauthorized
        window.location.href = process.env.REACT_APP_FRONTEND_URL;
      }
      throw new Error(error.message);
    });
  return fetchResponse;
};

export const editPurchaseOrder = async (id, request) => {
  const settings = {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/purchase-order/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const deletePurchaseOrder = async (id) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_BASE_URL + `/mm/purchase-order/${id}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return new Error(e.message);
  }
};

export const getPurchaseOrderRequest = async (
  pageNo,
  perPageCount,
  options
) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = "";
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/purchase-order?page=${pageNo}&limit=${perPageCount}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getPurchaseOrderById = async (id) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/purchase-order/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const createInstallation = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/installation", settings);
    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const updateStatusInstallation = async (vehicleId) => {
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/mm/machine-requests/${vehicleId}?update_status=true`, [], {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const updateStatusPurchaseOrder = async (id) => {
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/mm/machine-requests/purchaseorders/${id}?update_status=true`, [], {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getInstallationRequest = async (pageNo, perPageCount, options) => {
  const settings = {
    method: "GET",
    headers: getHeaders(),
  };
  try {
    let query = "";
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/installation?page=${pageNo}&limit=${perPageCount}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getInstallationById = async (id) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/installation/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const editInstallation = async (form, id) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/mm/installation/${id}`, settings.body, { headers: settings.headers });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const deleteInstallationById = async (id) => {
  const settings = {
    method: "DELETE",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/installation/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getServiceRemainderRequestAPI = async (
  pageNo,
  perPageCount,
  id,
  options
) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/service-remainder?page=${pageNo}&limit=${perPageCount}&id=${id}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getServiceRemainder = async (pageNo, options, perPageCount, installationId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleServiceRemainder = '';
    if (id !== 0) {
      singleServiceRemainder = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/service-remainder/${installationId}/services${singleServiceRemainder}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const createServiceRemainder = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/service-remainder", settings);
    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getSingleServiceRemainder = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/service-remainder/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const editServiceRemainder = async (id, request) => {
  const settings = {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/service-remainder/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const deleteServiceRemainder = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/mm/service-remainder/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return new Error(error.response.data.data.message);
  }
};

export const getBreakdownRequestAPI = async (pageNo, perPageCount, id, options) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/breakdown?page=${pageNo}&limit=${perPageCount}&id=${id}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getSpare = async (pageNo, perPageCount, id, options) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/spares?page=${pageNo}&limit=${perPageCount}&installationId=${id}${query}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const createBreakdown = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + "/mm/breakdown", settings);
    if (!fetchResponse.ok) {
      const errorData = await fetchResponse.json();
      throw new Error(errorData.data.message);
    }
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const editBreakdown = async (id, request) => {
  const settings = {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL + `/mm/breakdown/${id}`, settings);
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getBreakdown = async (pageNo, options, perPageCount, installationId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleBreakdown = '';
    if (id !== 0) {
      singleBreakdown = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/breakdown/${installationId}/breakdowns${singleBreakdown}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getSingleBreakdown = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/breakdown/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const deleteBreakdown = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/mm/breakdown/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return new Error(error.response.data.data.message);
  }
}

export const createSpare = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/mm/spares', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getSpareOld = async (pageNo, options, perPageCount, installationId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleSpare = '';
    if (id !== 0) {
      singleSpare = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/mm/spares/${installationId}/spares${singleSpare}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getSingleSpare = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/spares/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const editSpare = async (request, id) => {
  const settings = {
    headers: getHeaders(true),
    body: request,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + '/mm/spares/' + id, settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(error.response.data.data.message);
  }
};

export const deleteSpare = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/mm/spares/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return new Error(error.response.data.data.message);
  }
};

export const createResellScrap = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try{

    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/mm/resell-scrap', settings.body, { headers: settings.headers });
    return res.data;
  } catch (e){
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getSingleResellScrap = async (id) => {
  const settings = {
    method: "GET",
    headers: getHeaders()
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      `/mm/resell-scrap/instalation/${id}`,
      settings
    );
    const data = await fetchResponse.json();
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const transferMachineRequest = async (request) => {
  const settings = {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(request)
  };
  try {
    const fetchResponse = await fetch(process.env.REACT_APP_BASE_URL +
      "/mm/installation/transfer-to-factory",
      settings
    );
    const data = await fetchResponse.json();
    if (fetchResponse.status !== 200) {
      throw new Error(data);
    }
    return data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw e.message;
  }
};

export const getAllDashboardCount = async (factoryId_, status) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/installation/activeCount?factoryId=${factoryId_}&status=${status}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};
export const getMac = async (factoryId_, status) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/machine/byCount?factoryId=${factoryId_}&status=${status}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getMachineDetailRequestReport = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/reports/vehicle-detail-request-report?vehicleId=${id}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getFullInstallationReport = async (id, isRunningVehicle) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/mm/reports/vehicle-detail-request-report?vehicleId=${id}&isRunningVehicle=${isRunningVehicle}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getFullInstallationReportOne = async (id, isInstalled) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/mm/reports/vehicle-detail-request-report-one?installId=${id}&isInstalled=${isInstalled}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getFullInstallationReportTwo = async (id, isInstalled) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/mm/reports/vehicle-detail-request-report-two?machineId=${id}&isInstalled=${isInstalled}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getFullInstallationReportThree = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/machine/report/${id}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getPurchaseOrderReport = async (factoryId, startDate, endDate, item, poNumber, section, initiatedBy, viewOnly) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/purchase-order/generate/reports?factoryId=${factoryId}&startDate=${startDate}&endDate=${endDate}&item=${item}&poNumber=${poNumber}&section=${section}&initiatedBy=${initiatedBy}&viewOnly=${viewOnly}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getMachineRequestReport = async (factoryId, startDate, endDate, model, status, section, initiatedBy, viewOnly) => {
  try {
    if (viewOnly === 'download') {
      viewOnly = await '';
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/machine/generate/reports?factoryId=${factoryId}&startDate=${startDate}&endDate=${endDate}&name=${model}&section=${section}&status=${status}&initiatedBy=${initiatedBy}&viewOnly=${viewOnly}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getInstallationReport = async (factoryId, startDate, endDate, item, itemNumber, section, viewOnly) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/installation/generate/reports?factoryId=${factoryId}&startDate=${startDate}&endDate=${endDate}&item=${item}&itemNumber=${itemNumber}&section=${section}&viewOnly=${viewOnly}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getServiceRemainderReport = async (factoryId, startDate, endDate, name, serviceStartDate, serviceEndDate, status, section, viewOnly) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/service-remainder/generate/reports?factoryId=${factoryId}&startDate=${startDate}&endDate=${endDate}&name=${name}&servicedStartDate=${serviceStartDate}&servicedEndDate=${serviceEndDate}&serviceStatus=${status}&section=${section}&viewOnly=${viewOnly}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getBreakdownReport = async (factoryId, startDate, endDate, name, serviceStartDate, serviceEndDate, breakdownStatus, section, viewOnly) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/breakdown/generate/reports?factoryId=${factoryId}&startDate=${startDate}&endDate=${endDate}&name=${name}&servicedStartDate=${serviceStartDate}&servicedEndDate=${serviceEndDate}&repairStatus=${breakdownStatus}&section=${section}&viewOnly=${viewOnly}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getSinglePurchaseOrderReport = async (id, machineId) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/mm/reports/purchase-order-reportss?purchaseId=${id}&machineId=${machineId}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const getSingleServiceInfo = async (id, installationId, machineType) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
      `/mm/reports/service-info?serviceId=${id}&installationId=${installationId}&machineType=${machineType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    return e;
  }
};

export const createAfterPurchaseOrder = async (form, after, runningId, machineRequestId) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL +
      '/mm/machine-requests/' +
      machineRequestId +
      '/quotations/' +
      0 +
      `/purchaseorder?after=${after}&runningId=${runningId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(error.response.data.data.message);
  }
};

export const createAfterMachineRequest = async (form, after, runningId) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL + `/mm/machine-requests?after=${after}&runningId=${runningId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getUpcomingServices = async (factoryId_, status, days) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/installation/getDues?factoryId=${factoryId_}&status=${status}&days=${days}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};

export const getOverdueServices = async (factoryId_, status, days) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/mm/installation/getDues?factoryId=${factoryId_}&status=${status}&days=${days}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e?.response?.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    throw new Error(e.message);
  }
};